import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect } from 'react';
import { BKJButton } from '../BKJButton/index.js';
import { BKJDialogWrapper, Title, CloseIcon, ButtonGroup, TextWrapper, CloseIconWrapper, } from './BKJDialogChildren.styled.js';
const CancelVariantMap = {
    Danger: 'PurpleOutlined',
    Default: 'PurpleOutlined',
};
const ActionVariantMap = {
    Danger: 'RedSolid',
    Default: 'PurpleSolid',
};
export const BKJDialogChildren = forwardRef(({ variant, title, cancelLabel, actionLabel, onAction, onCancel, onClose, onChange, children, width, ...rest }, ref) => {
    const handleKeyUp = useCallback((event) => {
        if (event.key === 'Escape') {
            onClose();
        }
    }, [onClose]);
    useEffect(() => {
        document.addEventListener('keyup', handleKeyUp);
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, [handleKeyUp]);
    return (_jsxs(BKJDialogWrapper, { ...rest, variant: variant, ref: ref, children: [_jsx(CloseIconWrapper, { onClick: onClose, type: "button", "aria-label": "Close", children: _jsx(CloseIcon, { iconName: "CloseBold" }) }), _jsx(TextWrapper, { children: _jsx(Title, { children: title }) }), children, _jsxs(ButtonGroup, { children: [_jsx(BKJButton, { variant: CancelVariantMap[variant], onClick: onCancel, width: width, children: cancelLabel }), _jsx(BKJButton, { variant: ActionVariantMap[variant], onClick: onAction, width: width, children: actionLabel })] })] }));
});
//# sourceMappingURL=BKJDialogChildren.js.map